import React from "react";
import "./Booking_Form.css";
import { Form } from "react-bootstrap";
import "../../common/common-css/CommonCss.css";
import Start_Btn from "../../common/start-btn/Start_Btn";

const Booking_Form = () => {
  return (
    <div className="Booking_Form_div">
      <Form className="custom_form">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12 mb-3">
            <Form.Group controlId="fullName">
              <Form.Label>Full Name</Form.Label>
              <Form.Control type="text" placeholder="Enter full Name" />
            </Form.Group>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-9 mb-3">
            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control type="text" placeholder="Enter Phone Number" />
            </Form.Group>
          </div>

          <div className="col-lg-2 col-md-2 col-sm-3 mb-3">
            <Form.Group controlId="age">
              <Form.Label>age</Form.Label>
              <Form.Control type="number" placeholder="eg.26" />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
            <Form.Group controlId="email">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter Email" />
            </Form.Group>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
            <Form.Group controlId="currentOccupation">
              <Form.Label>Current Occupation</Form.Label>
              <Form.Control type="text" placeholder="eg.Student" />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
            <Form.Group controlId="interestedLocation">
              <Form.Label>Interested Location</Form.Label>
              <Form.Control type="text" placeholder="eg.Out of Maharashtra" />
            </Form.Group>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
            <Form.Group controlId="interestedCareer">
              <Form.Label>Interested Career</Form.Label>
              <Form.Control type="text" placeholder="eg.Out of Maharashtra" />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <Form.Group controlId="educationDetails">
              <Form.Label>Education Details</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                className="education-textarea"
                placeholder="Please provide accurate information about your current academic qualification, including your education level, stream (if applicable), and institution. This information helps us analyze your profile effectively and provide suitable career recommendations."
              />
            </Form.Group>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <div className="btn_div">
              <Start_Btn text="Go To Tests" link="/test-instructions" />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Booking_Form;
